// extracted by mini-css-extract-plugin
export default {"lista":"EscolhaIcone_lista__FOtN7","icone":"EscolhaIcone_icone__D0SKv","ativo":"EscolhaIcone_ativo__yUAwd"};